import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Kicker } from "@/components/Section";
import { toast } from "sonner";
import { AdminAPI } from "@/lib/api";
import { setAuthSession, getAuthToken, clearAuthSession } from "@/lib/authStorage";

export default function AdminLogin() {
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (getAuthToken()) {
            AdminAPI.me()
                .then(() => nav("/admin"))
                .catch(() => clearAuthSession());
        }
    }, [nav]);

    const submit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const res = await AdminAPI.login(email, password);
            setAuthSession(res.access_token, res.email);
            toast.success("Welcome back.");
            nav("/admin");
        } catch (err) {
            toast.error("Invalid credentials. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--lux-paper))] px-4">
            <div className="w-full max-w-md bg-[hsl(var(--lux-porcelain))] border border-border rounded-[2px] p-8 sm:p-10">
                <Kicker>Studio</Kicker>
                <h1 className="font-serif-display text-3xl mt-3">Sign in to the studio.</h1>
                <p className="mt-3 text-sm text-muted-foreground">For Elizaveta and authorised studio team only.</p>
                <form data-testid="admin-login-form" onSubmit={submit} className="mt-8 space-y-5">
                    <label className="block">
                        <span className="kicker block mb-2">Email</span>
                        <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </label>
                    <label className="block">
                        <span className="kicker block mb-2">Password</span>
                        <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    </label>
                    <Button
                        data-testid="admin-login-submit-button"
                        type="submit"
                        disabled={loading}
                        className="w-full bg-foreground text-background hover:bg-foreground/90 rounded-full h-11 text-[11px] tracking-[0.22em] uppercase"
                    >
                        {loading ? "Signing in…" : "Sign in"}
                    </Button>
                </form>
                <p className="mt-6 text-xs text-muted-foreground">
                    Default test credentials: <span className="font-mono">elizaveta@admin.com</span> / <span className="font-mono">Eliza@2025</span>
                </p>
            </div>
        </div>
    );
}
